import { MasterDataContainer } from '../../dataAccess/masterDataContainer';
import { WinDspInfoCacheViewModel } from './winDspInfoCacheViewModel';

export class WinDspInfoCacheContainer extends MasterDataContainer<WinDspInfoCacheViewModel> {
    constructor(models: Array<WinDspInfoCacheViewModel>, dataYear: number, version: Date) {
        super(models, dataYear, version);
    }
}
